<script>
    import {fade, slide} from 'svelte/transition';
    import {flip} from 'svelte/animate';
    import {clickOutside} from '../lib/clickOutside.js';
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import clocking from "../stores/clocking";
    import TodoItem from "./TodoItem.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import {setFocusTo, getWeeksDiff} from "../lib/lib";
    import InputAutosize from "../components/controls/InputAutosize.svelte";
    import ComponentLoader from "../components/ComponentLoader.svelte";
    import Notifier from "../stores/notifier";

    let list = null;
    // let selectedId = null;
    let todoTitle = '';
    let editingId = null;
    let search = {
        status: 0,
    }
    let showDropdown = false;

    const load = () => {
        const onSuccess = result => {
            list = result;
            let today = new Date();
            list.map(item => {
                item.weeks_passed = getWeeksDiff(today, new Date(item.created_at));
                delete (item.created_at);
            });
        }

        const onFailure = err => {
        };

        list = null;
        R.handle(R.todo.index, search, onSuccess, onFailure, LOADER.NONE);
    }

    const onToggleTodo = () => {
        $app.todoExpanded = !$app.todoExpanded;
    }

    const onCreate = () => {
        const onSuccess = result => {
            list = [{
                id: result.id,
                title: result.title,
                weeks_passed: 0,
            }, ...list];
            $app.todos++;
            todoTitle = '';
            setFocusTo(`todoTitle-${result.id}`);
        }

        const onFailure = err => {
        };

        todoTitle = todoTitle.trim();
        if (!todoTitle) {
            return;
        }

        let data = {
            id: 0,
            title: todoTitle,
        }

        R.handle(R.todo.create, data, onSuccess, onFailure, LOADER.NONE);
    }

    const setOrder = () => {
        const onSuccess = result => {
        }

        const onFailure = err => {
        };

        let ids = list.map(item => item.id);

        R.handle(R.todo.setOrder, ids, onSuccess, onFailure, LOADER.NONE);
    }

    const onEdit = ({detail}) => {
        editingId = detail;
    }

    const onChange = ({detail}) => {
        let item = list.find(x => x.id == detail.id);
        if (item) {
            item.title = detail.title;
            list = list;
        }
    }

    const onRemove = ({detail}) => {
        list = list.filter(x => x.id != detail.id);

        if (detail.action === 'delete') {
            if (search.status == 0) {
                $app.todos = list.length;
            }
            return;
        }

        if (detail.status == 1) {
            $app.todos--;
        } else {
            $app.todos++;
        }
    }

    const toggleSearchStatus = () => {
        showDropdown = false;
        search.status = search.status == 0 ? 1 : 0;
        load();
    }

    const onClockingTask = ({detail}) => {
        if (clocking.onProgress()) {
            Notifier.showError("Υπάρχει ήδη μια εργασία σε χρονομέτρηση!");
            return;
        }

        clocking.start({
            name: detail.title,
            project_id: detail.project_id,
            project: detail.project
        });
    }


    /* Drag drop handlers */
    let hovering = false;

    const dragstart = (event, i) => {
        // selectedId = list[i].id;
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = list;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        list = newTracklist;
        hovering = null;
        setOrder();
    }


    $:{
        if ($app.todoExpanded && list == null) {
            list = [];
            load();
        } else if (!$app.todoExpanded && list) {
            setTimeout(() => {
                list = null;
            }, 200);
        }
    }
</script>

<div class="todo-sidebar" class:open={ $app.todoExpanded }>
    <div class="todo-header pointer" on:click={ onToggleTodo }>
        <h6 class="mb-0">Να κάνω</h6>
        <div class="toggler">
            <div class="icon">
                <AppIcon icon="chevron-right" strokeWidth="2" size="18"/>
            </div>
        </div>
    </div>
    <div class="todo-content">
        <div class="d-flex align-items-center mb-3">
            <div class="new-todo">
                {#if search.status == 0}
                    <InputAutosize css="form-control" bind:value="{ todoTitle }"
                                   on:change={ onCreate }
                                   placeholder="προσθήκη εργασίας"/>
                {:else}
                    <h6 class="mb-0">Ολοκληρωμένες εργασίες</h6>
                {/if}
            </div>
            <div class="dropdown-container more-actions" use:clickOutside
                 on:click_outside="{ () => showDropdown = false }">
                <button class="btn px-1" on:click={ () => showDropdown = !showDropdown }>
                    <AppIcon icon="more-vertical" size="18"/>
                </button>
                {#if showDropdown}
                    <ul class="dropdown right">
                        {#if search.status == 0}
                            <li class="dropdown-item pointer" on:click={ toggleSearchStatus }>Εμφάνιση ολοκληρωμένων
                            </li>
                        {:else}
                            <li class="dropdown-item pointer" on:click={ toggleSearchStatus }>Εμφάνιση ενεργών</li>
                        {/if}
                    </ul>
                {/if}
            </div>
        </div>
        <div class="todo-wrapper">
            {#if !list}
                <div class="list-loader">
                    <ComponentLoader loading size="80" color="#ccc"/>
                </div>
            {:else}
                <div class="todo-list">
                    {#each list as todo, index (todo.id)}
                        <div class="todo-item"
                             animate:flip="{{ duration: 100 }}"
                             on:dragstart={event => dragstart(event, index)}
                             on:dragenter={() => hovering = index}
                             on:drop|preventDefault={event => drop(event, index)}
                             ondragover="return false"
                             draggable={ editingId != todo.id }
                             class:drag-over={hovering === index}
                        >
                            <TodoItem {todo} on:edit={ onEdit } on:change={ onChange }
                                      on:remove={ onRemove }
                                      on:clockingtask={ onClockingTask }/>
                        </div>
                    {/each}
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    .todo-sidebar {
        background: #fff;
        position: fixed;
        top: var(--header-height);
        right: 0;
        bottom: 0;
        transform: translateX(100%);
        width: 300px;
        -webkit-box-shadow: -2px 0 4px rgba(0, 0, 0, .08);
        box-shadow: -2px 0 4px rgba(0, 0, 0, .08);
        transition: all .2s ease-in-out;
    }

    .todo-sidebar.open {
        transform: translateX(0);
    }

    .todo-sidebar .todo-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #5d5a68;
        padding: 20px 5px 15px 15px;
    }

    .todo-sidebar .todo-content {
        padding: 10px 0 10px 0;
    }

    .todo-sidebar .todo-content .todo-wrapper {
        position: relative;
        height: calc(100vh - 165px);
        overflow-y: auto;
        /*padding-right: 10px;*/
    }

    .todo-sidebar .todo-content .todo-wrapper .list-loader {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0.5;
    }

    .todo-sidebar .todo-header .toggler {

    }

    .todo-sidebar .todo-header .toggler .icon {

    }

    .todo-item {
        border-bottom: 1px solid #dddde0;
        padding: 10px 0;
        margin-bottom: 10px;
    }

    .todo-item:last-child {
        border-bottom: none;
    }

    .todo-item.drag-over {
        border-bottom: 2px solid #ea5455;
    }

    .todo-content .new-todo {
        width: calc(100% - 28px);
        padding-left: 15px;
    }

    .todo-content .more-actions {

    }

    @media (max-width: 576px) {
        .todo-sidebar {
            width: 100%;
        }
    }

    /*.ec-element {*/
    /*    height: max-content;*/
    /*    max-height: 1000px;*/

    /*    transition: .3s all ease;*/
    /*}*/

    /*.ec-element.collapsed {*/
    /*    max-height: 0 !important;*/
    /*    overflow: hidden;*/

    /*    transition: .3s all ease;*/
    /*}*/
</style>